import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "icn-graphics-rule-wizard-nav",
  templateUrl: "./graphics-rule-wizard-nav.component.html",
  styleUrls: ["./graphics-rule-wizard-nav.component.scss"],
})
export class GraphicsRuleWizardNavComponent {
  @Input()
  backHidden: boolean;

  @Input()
  nextHidden: boolean;

  @Input()
  nextDisabled: boolean;

  @Output()
  back = new EventEmitter<boolean>();

  @Output()
  next = new EventEmitter<boolean>();
}
